module.exports = __webpack_public_path__ + "static/media/gcdef_10029.e498049d.ico";